<template>
    <div>
        <span v-html="title"></span>
    </div>
</template>
<script>
export default {
    name: 'DetailElement',
    props: ['title', 'type', 'sign'],
    data() {
        return {}
    }
}
</script>
<style lang="scss">
.sign {
    font-size: 11px;
    color: #ccc;
}
</style>